import { React } from "react";
import Icon, { IconTypes } from "../../../../common/Icon";

function CourseLandingPageExperience() {

  const experiences = [
    { text: "Each lecture is recorded and posted on the course site every week for you to revisit any lesson on-demand, as needed - with the added benefit of the ‘pause button’ to take more detailed notes!", icon: IconTypes.Play, size: "2x", iconClass: "experience-icon-play" },
    { text: "Our professors conduct our classes LIVE and will take questions at the conclusion of each lecture. Those who volunteer as an on-screen panelist have the opportunity to interact with the professor.", icon: IconTypes.Hand, size: "4x", iconClass: "experience-icon-hand" },
    { text: "We are a community!  In this course there will be hundreds of others learning alongside you from all around the world. Join our preclasses to have time for fellowship and informal learning each week.", icon: IconTypes.Class, size: "4x", iconClass: "experience-icon-class" }
  ];
  
  return (
    <div className="CourseLandingPage-experience container">
      <div className="container-content">
        <div className="heading-container">
          <h2>
            Partake <em><span className="lowercase">in the</span> ICC<br/><span className="lowercase">student</span></em> experience
          </h2>
          <p>
            The Institute of Catholic Culture will conduct this course LIVE over Zoom webinar, and it allows you - in real time - to study alongside hundreds of fellow students who will be joining from countries all around the world. We are very pleased to offer this learning experience absolutely FREE of charge!
          </p>
        </div>
        <div className="experiences-container">
          {experiences.map((experience, index) => (
            <div className="experience-container" key={index}>
              <div className="experience-icon">
                <Icon 
                  type={experience.icon}
                  size={experience.size}
                  className={experience.iconClass}
                />
              </div>
              <p className="description">{experience.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CourseLandingPageExperience;